import { render, staticRenderFns } from "./RelatorioExportarSolicitacoes.vue?vue&type=template&id=304e866a"
import script from "./RelatorioExportarSolicitacoes.vue?vue&type=script&lang=js"
export * from "./RelatorioExportarSolicitacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports